import type { ClientPortfolioPaymentFrequencyEnum } from "web_myplann/Infrastructure/Api/Api";
import { MONTHS_PER_PAYMENT } from "web_myplann/Shared/constants";

export const getMonthlyPayment = (
	amount: number | null | undefined,
	frequency: ClientPortfolioPaymentFrequencyEnum | null | undefined,
): number | undefined => {
	const months = frequency ? MONTHS_PER_PAYMENT[frequency] : undefined;
	if (amount === null || amount === undefined || !months) return undefined;
	return amount / months;
};
